import { getUniversalEnv } from 'app/lib/get-universal-env';
import { isSSR } from 'app/packages/components';

export const getUniversalBackendHost = () => {
  if (isSSR) {
    return getUniversalEnv('BACKEND_HOST_FOR_SERVER');
  }
  return getUniversalEnv('BACKEND_HOST_FOR_CLIENT');
};
